<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="11.2" height="14" viewBox="0 0 11.2 14" class="scaling-svg">
      <g transform="translate(-75 -100)">
        <g transform="translate(75 100)">
          <g transform="translate(0 0)">
            <path
              d="M9.8,14H1.4A1.4,1.4,0,0,1,0,12.6V1.4A1.4,1.4,0,0,1,1.4,0h7l2.8,2.8v9.8A1.4,1.4,0,0,1,9.8,14ZM2.1,1.4a.7.7,0,0,0-.7.7v9.8a.7.7,0,0,0,.7.7h7a.7.7,0,0,0,.7-.7V4.2H7V1.4Zm6.3,0V2.8H9.8Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <path
          d="M1.2,1.95a.757.757,0,0,1,1.29.534.491.491,0,1,0,.981,0A1.739,1.739,0,0,0,2.227.819V.491a.491.491,0,0,0-.981,0V.818a1.677,1.677,0,0,0-.181,3.165l.967.4A.694.694,0,0,1,2.29,5.491.757.757,0,0,1,.981,4.976a.491.491,0,0,0-.981,0A1.736,1.736,0,0,0,1.246,6.641V6.97a.491.491,0,0,0,.981,0V6.641a1.721,1.721,0,0,0,.731-.43,1.676,1.676,0,0,0-.55-2.733l-.967-.4A.693.693,0,0,1,1.2,1.95Z"
          transform="translate(78.863 103.263)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CashDocumentIcon extends Vue {}
</script>

<style>
</style>
